/* eslint-disable */ 
import { createApp } from 'vue';
import App from './App.vue';
import PrimeVue from 'primevue/config';
import router from './router'; // Import the router
import PrimeButton from 'primevue/button';
import PrimeInputText from 'primevue/inputtext';
import PrimeDropdown from 'primevue/dropdown';
import PrimeRadioButton from 'primevue/radiobutton';
import PrimeCalendar from 'primevue/calendar';
import PrimeSelectButton from 'primevue/selectbutton';
import PrimeCheckbox from 'primevue/checkbox';
import PrimeSteps from 'primevue/steps';
import InputOtp from 'primevue/inputotp';
import Textarea from 'primevue/textarea';
import PrimeCard from 'primevue/card';
import PrimeDivider from 'primevue/divider';
import PrimeDialog from 'primevue/dialog';
import ConfirmDialog from 'primevue/confirmdialog';
import FloatLabel from 'primevue/floatlabel';
import FileUpload from 'primevue/fileupload';
import ConfirmationService from 'primevue/confirmationservice';
import PrimeToast from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import ProgressSpinner from 'primevue/progressspinner';
import FileUploader from './components/FileUploader.vue';
import ProgressBar from 'primevue/progressbar';
import InputNumber from 'primevue/inputnumber';
import Fieldset from 'primevue/fieldset';
import MultiSelect from 'primevue/multiselect';


import { utils } from './utils';
import { AppMenus } from './menus';

import 'primevue/resources/themes/saga-blue/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';
import '/node_modules/primeflex/primeflex.css'




const app = createApp(App);
app.use(PrimeVue);
app.use(router); // Use the router
app.component('PrimeButton', PrimeButton);
app.component('PrimeInputText', PrimeInputText);
app.component('PrimeDropdown', PrimeDropdown);
app.component('PrimeRadioButton', PrimeRadioButton);
app.component('PrimeCalendar', PrimeCalendar);
app.component('PrimeSelectButton', PrimeSelectButton);
app.component('PrimeCheckbox', PrimeCheckbox);
app.component('PrimeSteps', PrimeSteps);
app.component('FileUpload', FileUpload);
app.component('PrimeDialog', PrimeDialog);
app.component('ConfirmDialog', ConfirmDialog);
app.component('PrimeToast', PrimeToast);
app.component('TextArea', Textarea);
app.component('PrimeCard', PrimeCard);
app.component('ProgressSpinner', ProgressSpinner);
app.component('FloatLabel', FloatLabel);
app.component('InputOtp', InputOtp);
app.component('PrimeDivider', PrimeDivider);
app.component('FileUploader', FileUploader);
app.component('ProgressBar', ProgressBar);
app.component('InputNumber',InputNumber);
app.component('Fieldset',Fieldset);
app.component('PrimeCheckbox', PrimeCheckbox);
app.component('MultiSelect', MultiSelect);
app.use(ConfirmationService);
app.use(ToastService);

app.config.globalProperties.$menus = AppMenus;
app.config.globalProperties.$utils = utils;

app.mount('#app');

